// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-type-section {
  border-bottom: 1px solid var(--border-tertiary);
}

.chart-type-section:last-child {
  border-bottom: none;
}

.chart-type-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  user-select: none;
  text-align: left;
}

.chart-type-row:hover {
  background: var(--color-brand-hover2, #f9e2d6);
}

.chart-type-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.chart-type-icon svg {
  width: 20px;
  height: 20px;
}

.chart-type-icon svg path {
  fill: var(--accent-secondary);
}

.chart-type-row-active .chart-type-icon svg path {
  fill: var(--color-brand);
}

.chart-type-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-type-arrow-up {
  transform: rotate(180deg);
}

.chart-type-content {
  padding: 4px 16px 20px 52px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chart-type-color-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.chart-type-color-label {
  color: var(--text-secondary);
  white-space: nowrap;
}

.chart-type-color-label--paired {
  min-width: 80px;
}

.chart-type-color-sub {
  color: var(--text-secondary);
}
.chart-type-selector {
  display: flex;
  gap: 4px;
}
.chart-type-style-row {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
}
.chart-type-line-style .select-dropdown-trigger {
  width: 80px;
  padding: 8px 8px 8px 16px;
}

@container (max-width: 600px) {
  .chart-type-popup {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/settings/ChartTypeSettings.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".chart-type-section {\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.chart-type-section:last-child {\n  border-bottom: none;\n}\n\n.chart-type-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  cursor: pointer;\n  user-select: none;\n  text-align: left;\n}\n\n.chart-type-row:hover {\n  background: var(--color-brand-hover2, #f9e2d6);\n}\n\n.chart-type-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n.chart-type-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.chart-type-icon svg path {\n  fill: var(--accent-secondary);\n}\n\n.chart-type-row-active .chart-type-icon svg path {\n  fill: var(--color-brand);\n}\n\n.chart-type-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chart-type-arrow-up {\n  transform: rotate(180deg);\n}\n\n.chart-type-content {\n  padding: 4px 16px 20px 52px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.chart-type-color-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n}\n\n.chart-type-color-label {\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.chart-type-color-label--paired {\n  min-width: 80px;\n}\n\n.chart-type-color-sub {\n  color: var(--text-secondary);\n}\n.chart-type-selector {\n  display: flex;\n  gap: 4px;\n}\n.chart-type-style-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  justify-content: flex-end;\n}\n.chart-type-line-style .select-dropdown-trigger {\n  width: 80px;\n  padding: 8px 8px 8px 16px;\n}\n\n@container (max-width: 600px) {\n  .chart-type-popup {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
